(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  /* =========================================================
     Footer social icons - Magnetic Hover
     The link remains fixed; only the icon follows the pointer.
     ========================================================= */
  const initFooterMagneticSocialIcons = (scope = document) => {
    const supportsFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!supportsFinePointer || prefersReducedMotion) return;

    const socialLinks = scope.querySelectorAll('.footer .list-social__link');

    socialLinks.forEach((link) => {
      if (link.dataset.magneticSocialReady === 'true') return;
      link.dataset.magneticSocialReady = 'true';

      const maxMove = 10;
      const strength = 0.28;
      const ease = 0.34;

      let targetX = 0;
      let targetY = 0;
      let currentX = 0;
      let currentY = 0;
      let frameId = null;

      const animate = () => {
        currentX += (targetX - currentX) * ease;
        currentY += (targetY - currentY) * ease;

        link.style.setProperty('--magnetic-x', `${currentX.toFixed(2)}px`);
        link.style.setProperty('--magnetic-y', `${currentY.toFixed(2)}px`);

        const stillMoving =
          Math.abs(targetX - currentX) > 0.05 ||
          Math.abs(targetY - currentY) > 0.05;

        if (stillMoving) {
          frameId = requestAnimationFrame(animate);
        } else {
          currentX = targetX;
          currentY = targetY;
          link.style.setProperty('--magnetic-x', `${currentX.toFixed(2)}px`);
          link.style.setProperty('--magnetic-y', `${currentY.toFixed(2)}px`);
          frameId = null;
        }
      };

      const requestAnimation = () => {
        if (frameId === null) {
          frameId = requestAnimationFrame(animate);
        }
      };

      const moveIcon = (event) => {
        const rect = link.getBoundingClientRect();
        const offsetX = event.clientX - (rect.left + rect.width / 2);
        const offsetY = event.clientY - (rect.top + rect.height / 2);

        targetX = Math.max(-maxMove, Math.min(maxMove, offsetX * strength));
        targetY = Math.max(-maxMove, Math.min(maxMove, offsetY * strength));

        requestAnimation();
      };

      const activate = () => {
        link.classList.add('is-magnetic-active');
      };

      const resetIcon = () => {
        link.classList.remove('is-magnetic-active');
        targetX = 0;
        targetY = 0;
        requestAnimation();
      };

      link.addEventListener('pointerenter', activate);
      link.addEventListener('pointermove', moveIcon);
      link.addEventListener('pointerleave', resetIcon);
      link.addEventListener('pointercancel', resetIcon);
      link.addEventListener('blur', resetIcon);
    });
  };

  const bootFooterMagneticSocialIcons = () => {
    initFooterMagneticSocialIcons(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFooterMagneticSocialIcons, { once: true });
  } else {
    bootFooterMagneticSocialIcons();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFooterMagneticSocialIcons(event.target);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always'
        || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => this.preventReveal = true;

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {

      const visualHeader =
        this.querySelector('.header')
        || this;

      document.documentElement.style.setProperty(
        '--header-height',
        `${visualHeader.offsetHeight}px`
      );

    }

    disconnectedCallback() {

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }

    createObserver() {

      if (this.classList.contains('bw-overlay-header')) {
        this.headerBounds = {
          top: 0,
          bottom: this.offsetHeight || 80
        };
        return;
      }

      let observer =
        new IntersectionObserver(
          (entries, observer) => {

            this.headerBounds =
              entries[0].intersectionRect;

            observer.disconnect();

          }
        );

      observer.observe(this.header);

    }

    onScroll() {

      const scrollTop =
        window.pageYOffset
        || document.documentElement.scrollTop;

      if (
        this.predictiveSearch
        && this.predictiveSearch.isOpen
      ) return;

      if (
        scrollTop > this.currentScrollTop
        && scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) return;

        requestAnimationFrame(
          this.hide.bind(this)
        );

      } else if (
        scrollTop < this.currentScrollTop
        && scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        } else {

          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(() => {

              this.preventReveal = false;

            }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );

      }

      this.currentScrollTop =
        scrollTop;

    }

    hide() {

      if (
        this.headerIsAlwaysSticky
      ) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }

    reveal() {

      if (
        this.headerIsAlwaysSticky
      ) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }

    reset() {

      if (
        this.headerIsAlwaysSticky
      ) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }

    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures
        || this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        disclosure => disclosure.close()
      );

    }

    closeSearchModal() {

      this.searchModal =
        this.searchModal
        || this.header.querySelector(
          'details-modal'
        );

      this.searchModal.close(false);

    }

  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );
  
  class StaticHeader extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.header =
        document.querySelector(
          '.section-header'
        );

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );

    }

    setHeaderHeight() {

      const visualHeader =
        this.querySelector('.header')
        || this;

      document.documentElement.style.setProperty(
        '--header-height',
        `${visualHeader.offsetHeight}px`
      );

    }

  }

  customElements.define(
    'static-header',
    StaticHeader
  );


  } catch(e) { console.error(e); }
})();
})();
